

const searchTrigger = function() {
	var search_wrap = $('.search-style-fullscreen');
	var search_trigger = $('.header-search-trigger');
	var search_field = search_wrap.find('.search-field');
	var search_form = $('.search-form');

	search_trigger.on('click', function(e) {
		if ( ! search_wrap.hasClass('search-opened') ) {
			search_wrap.addClass('search-opened');
			search_field.get(0).focus();

		} else if (search_field.val() == '') {
			if ( search_wrap.hasClass('search-opened') )
				search_wrap.removeClass('search-opened');
			else search_field.get(0).focus();

		} else {
			 search_wrap.find('form').get(0).submit();
		}

		$('html').addClass( 'disable-scroll' );
		e.preventDefault();
		return false;
	});


	search_form.prepend("<div class='keyword-search'><h2>Search for a keyword:</h2></div>")
	search_form.append("<div><a class='search-close search-close-after'>Cancel</a></div>");

	search_wrap.find('.search-close').on('click', function(e) {
		search_wrap.removeClass('search-opened');
		$('html').removeClass( 'disable-scroll' );
		e.preventDefault();
		return false;
	});
};

searchTrigger();